import { inject, Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import {
  AmoxcalliLoginResponseDto,
  apiRefreshTokenRotatePost$Json,
} from 'amoxcalli-identity-api';
import { AuthActions } from '../state/auth/auth.actions';
import { environment } from '../../../environments/environment';

const TOKEN_KEY = 'amxp_token';
const REFRESH_KEY = 'amxp_refresh';

@Injectable({ providedIn: 'root' })
export class TokenService {
  private readonly http: HttpClient;
  private readonly store = inject(Store);

  constructor(httpBackend: HttpBackend) {
    this.http = new HttpClient(httpBackend);
  }

  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_KEY);
  }

  setTokens(token: string, refreshToken: string): void {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(REFRESH_KEY, refreshToken);
  }

  clearTokens(): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_KEY);
  }

  refresh(): Observable<string> {
    const refreshToken = this.getRefreshToken();
    if (!refreshToken) {
      return throwError(() => new Error('No refresh token available'));
    }

    return apiRefreshTokenRotatePost$Json(this.http, environment.serverUrl.identity, {
      body: { refreshToken },
    }).pipe(
      map((response) => {
        const dto = response.body as AmoxcalliLoginResponseDto;
        const newToken = dto.accessToken ?? '';
        const newRefresh = dto.refreshToken ?? '';
        this.setTokens(newToken, newRefresh);
        this.store.dispatch(AuthActions.refreshSuccess({ token: newToken, refreshToken: newRefresh }));
        return newToken;
      })
    );
  }
}
